import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { messages } from './messages';
import { ProductDetailsContext } from '../../../../context';

import style from './style.module.css';

/**
 * InventoryBundleComponent displays information about a product bundle's name, SKU, and inventory details.
 * It provides the ability to open a modal for a different product via the provided button.
 * @param {object} props - The component props.
 * @param {string} props.productId - The ID of the product.
 * @param {string} props.sku - The SKU of the product.
 * @param {string} props.name - The name of the product.
 * @param {object} [props.inventory] - Inventory details of the product (stock, allocated, available).
 * @param {number} [props.quantity] - The quantity required for the bundle.
 * @returns {React.Element} A rendered InventoryBundleComponent.
 */
export const InventoryBundleComponent = ({ productId, sku, name, inventory, quantity }) => {
  const { openDifferentProductModal } = useContext(ProductDetailsContext);
  const intl = useIntl();

  return (
    <div aria-label={intl.formatMessage(messages.bundleForSku, { sku })} className={style['bundle-component']}>
      <div>
        <Button onClick={() => openDifferentProductModal(productId)} theme='link'>
          {name}
        </Button>
        <Text
          className={style['bundle-component-sku']}
          formattedMessageValues={{ sku }}
          textType={TextType.Description}
          value={messages.productBundleComponentSku}
        />
      </div>
      <div aria-label={intl.formatMessage(messages.productBundleComponentOnHand)}>{inventory?.stock ?? 0}</div>
      <div aria-label={intl.formatMessage(messages.productBundleComponentQtyRequired)}>{quantity ?? 0}</div>
      <div aria-label={intl.formatMessage(messages.productBundleComponentAllocated)}>{inventory?.allocated ?? 0}</div>
      <div aria-label={intl.formatMessage(messages.productBundleComponentAvailable)}>{inventory?.available ?? 0}</div>
    </div>
  );
};
